export default __webpack_public_path__ + "static/Grass-81de3423f37418e32bc2f8ea59e0f6a8.svg";